module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c19282f27937a0db7e8146672018fa8b.jpg";